import { combineReducers } from 'redux';
import additionalQueryParams from './additionalQueryParams';
import aggregatedOverviewData from './aggregatedOverviewData';
import alerts from './alerts';
import analyze from './analyze';
import auth from './auth';
import automation from './automation';
import date from './dates';
import deals from './deals';
import dealsWithForecastCategories from './dealsWithForecastCategories';
import stagedDealsUpdates from './stagedDealsUpdates';
import dealValidation from './dealValidation';
import detail from './detail';
import displayOptions from './displayOptions';
import filters from './filters';
import forecast from './forecast';
import multiCurrency from './multiCurrency';
// @ts-expect-error untyped
import Notifications from 'ReduxMessenger/reducers/Notifications';
import onboardingSettings from './onboardingSettings';
import overview from './overview';
import owners from './owners';
import portalSettings from './portalSettings';
import properties from './properties';
import sorts from './sorts';
import tabs from './tabs';
import teams from './teams';
import users from './users';
import { wizard } from './wizard';
export default combineReducers({
  additionalQueryParams,
  aggregatedOverviewData,
  alerts,
  analyze,
  auth,
  automation,
  date,
  deals,
  dealsWithForecastCategories,
  dealValidation,
  detail,
  displayOptions,
  filters,
  forecast,
  multiCurrency,
  notifications: Notifications,
  onboardingSettings,
  overview,
  owners,
  portalSettings,
  properties,
  sorts,
  stagedDealsUpdates,
  tabs,
  teams,
  users,
  wizard
});